<h2 mat-dialog-title>{{ headerText$ | async }}</h2>
<mat-dialog-content class="content">
  @if (contactUsModalDescription$ | async; as description) {
    <p class="business-navbar__sales-info__description">{{ description }}</p>
  }
  @if ((hideSalespersonContact$ | async) === false && (salespersonContact$ | async); as contact) {
    <div class="business-navbar__sales-info__sales-card">
      <div class="business-navbar__sales-info__sales-card__picture">
        <glxy-avatar [src]="salespersonPicture$ | async" [width]="48"></glxy-avatar>
      </div>
      <div class="business-navbar__sales-info__sales-card__contact-details">
        <div class="business-navbar__sales-info__sales-card__contact-details__name">
          {{ contact.firstName }} {{ contact.lastName }}
        </div>
        <div class="business-navbar__sales-info__sales-card__contact-details__title">
          {{ contact.jobTitle }}
        </div>
        <div class="business-navbar__sales-info__sales-card__contact-details__phone-number">
          <a [href]="'tel:' + $safeNavigationMigration(contact?.phoneNumber)">
            {{ formatPhoneNumber($safeNavigationMigration(contact?.phoneNumber), contact.country) }}
          </a>
        </div>
        <div class="business-navbar__sales-info__sales-card__contact-details__email">
          <a [href]="'mailto:' + contact.email">{{ contact.email }}</a>
        </div>
        @if (!!contact?.meetingBookingUrl) {
          <div class="business-navbar__sales-info__sales-card__contact-details__booking-url">
            <bc-meeting-booking-url [bookingUrl]="$safeNavigationMigration(contact?.meetingBookingUrl)"></bc-meeting-booking-url>
          </div>
        }
      </div>
    </div>
  }
  @if (showSendMessageCard$ | async) {
    <div class="business-navbar__sales-info__message-card">
      <span class="business-navbar__sales-info__message-card__icon">
        <mat-icon>chat_bubble</mat-icon>
      </span>
      <div class="business-navbar__sales-info__message-card__label">
        {{ 'COMMON.SEND_US_A_MESSAGE' | translate }}
      </div>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions class="business-navbar__sales-info__actions">
  @if ((canAccessInbox$ | async) === true) {
    <inbox-button-send-message
      [config]="{
        currentParticipant: currentIAMParticipant$ | async,
        subjectParticipants: subjectParticipants$ | async,
        channel: conversationChannel
      }"
      (closeModal)="closeModal()"
    ></inbox-button-send-message>
  }
  @if ((showSupportCenterLink$ | async) && (supportCenterLinkUrl$ | async); as supportUrl) {
    @if ((canAccessInbox$ | async) === true) {
      <a
        mat-stroked-button
        class="business-navbar__sales-info__support-link"
        [href]="supportUrl"
        target="_blank"
        rel="noopener noreferrer"
      >
        <ng-container [ngTemplateOutlet]="supportLinkContent"></ng-container>
      </a>
    } @else {
      <a
        mat-flat-button
        color="primary"
        class="business-navbar__sales-info__support-link"
        [href]="supportUrl"
        target="_blank"
        rel="noopener noreferrer"
      >
        <ng-container [ngTemplateOutlet]="supportLinkContent"></ng-container>
      </a>
    }
  }
  <button (click)="closeModal()" mat-stroked-button class="business-navbar__sales-info__close">
    {{ 'COMMON.ACTION_LABELS.CLOSE' | translate }}
  </button>
</mat-dialog-actions>

<ng-template #supportLinkContent>
  <span class="business-navbar__sales-info__support-link__content">
    <mat-icon>open_in_new</mat-icon>
    <span>{{ (supportCenterLinkLabel$ | async) || ('COMMON.VISIT_SUPPORT_CENTER' | translate) }}</span>
  </span>
  <span class="visually-hidden">{{ 'COMMON.OPENS_IN_NEW_TAB' | translate }}</span>
</ng-template>
